export const AspectRatiosSubTitle = [
  {
    text: "Aspect ratios can be customized with modifier classes. By default the following ratio classes are provided:",
    code: "[ratio-1x1 / ratio-4x3 / ratio-16x9 / ratio-21x9]",
  },
  {
    text: ".",
  },
];

export const CustomRatioSubTitle = [
  {
    text: "Wrap any embed, like an ",
    code: "<iframe> ",
  },
  {
    text: ", in a parent element with ",
    code: "ratio ",
  },
  {
    text: "and an ",
    code: "aspect ratio ",
  },
  {
    text: "class. Here is a breakdown of these ratios: ",
    code: "ratio-4x3",
  },
  {
    text: ".",
  },
];

export const DefaultRatioSubTitle = [
    {
      text: "Wrap any embed, like an ",
      code: "<iframe> ",
    },
    {
      text: ", in a parent element with ",
      code: "ratio ",
    },
    {
      text: "and an ",
      code: "aspect ratio ",
    },
    {
      text: "class. Here is a breakdown of these ratios: ",
      code: "16x9 ratio",
    },
    {
      text: ".",
    },
  ];

export const AspectRatiosData = [
  { class: "ratio-1x1", src: "https://www.youtube.com/embed/AsZwvuUmHGU?si=LHExkFd586NQbVAG" },
  { class: "ratio-4x3", src: "https://www.youtube.com/embed/qDL2HBPy9uQ?si=yyIowrbZW-C-3lxd" },
  { class: "ratio-16x9", src: "https://www.youtube.com/embed/AsZwvuUmHGU?si=LHExkFd586NQbVAG" },
  { class: "ratio-21x9", src: "https://www.youtube.com/embed/qDL2HBPy9uQ?si=yyIowrbZW-C-3lxd" },
];
